/**
 * Click-to-zoom inside the product image lightbox. Dawn's "lightbox" mode
 * opens the gallery in a modal but its images are just fitted to the
 * screen; here a click toggles a 1:1 view of the 2000px original that
 * scrolls inside the modal, keeping the clicked point under the cursor
 * (click again to go back). Delegated on document so it covers the
 * modal whichever product/variant it was built for, including after
 * Dawn re-renders it on a variant change.
 */
(function () {
  document.addEventListener("click", function (e) {
    var img = e.target && e.target.closest && e.target.closest(".product-media-modal__content > img");
    if (!img) return;
    var box = img.getBoundingClientRect();
    var fx = (e.clientX - box.left) / box.width;
    var fy = (e.clientY - box.top) / box.height;
    var zoomed = img.classList.toggle("clvry-zoomed");
    var content = img.parentElement;
    if (zoomed) {
      // make sure the browser fetches the full-size file, not the fitted one
      if (!img.dataset.origSizes) img.dataset.origSizes = img.getAttribute("sizes") || "";
      img.sizes = "2000px";
      requestAnimationFrame(function () {
        var nb = img.getBoundingClientRect();
        content.scrollLeft += nb.left + fx * nb.width - e.clientX;
        content.scrollTop += nb.top + fy * nb.height - e.clientY;
      });
    } else {
      if (img.dataset.origSizes) img.setAttribute("sizes", img.dataset.origSizes);
      // back to the fitted view: the zoomed scroll offsets no longer apply, so
      // re-centre the image (otherwise it can be left sitting off to one side)
      requestAnimationFrame(function () {
        content.scrollLeft = (content.scrollWidth - content.clientWidth) / 2;
        content.scrollTop = Math.max(0, img.offsetTop - (content.clientHeight - img.getBoundingClientRect().height) / 2);
      });
    }
  });
})();

/* Phones: centre the enlarged image horizontally each time the lightbox
   opens (it is wider than the screen, see clvry-media-modal-size.css). */
(function () {
  function centre(modal) {
    if (window.innerWidth >= 750) return;
    var c = modal.querySelector(".product-media-modal__content");
    if (c) c.scrollLeft = (c.scrollWidth - c.clientWidth) / 2;
  }
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      var el = m.target;
      if (el.tagName === "PRODUCT-MODAL" && el.hasAttribute("open")) {
        requestAnimationFrame(function () { centre(el); });
        setTimeout(function () { centre(el); }, 150);
      }
    });
  }).observe(document.documentElement, { attributes: true, attributeFilter: ["open"], subtree: true });
})();
